import { api } from "@/lib/api";
import { usePolling } from "@/hooks/usePolling";
import { PlantMimic } from "@/components/mimic/PlantMimic";

export default function Mimic() {
  const { data, error } = usePolling(() => api.get("/mimic").then((r) => r.data), 5000);

  if (error) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="mimic-error">Could not load plant mimic. Retrying…</div>;

  return (
    <div className="space-y-4" data-testid="mimic-page">
      <h1 className="text-2xl font-bold font-heading text-[var(--oim-text)]">Plant Mimic</h1>
      <div className="text-xs text-[var(--oim-text-dim)]">Site → Chain → Process → System</div>
      <PlantMimic mimic={data} />
    </div>
  );
}
